import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
/**
 * Ez a pipe egy html tag-eket tartalmazó szöveget ágyaz be az innerHtml használatával
 * Példa:
 *
 * <div [innerHTML]="contactDescription | safeHtml"></div>
 *
 */
@Pipe({
  name: "safeHtml",
  pure: true
})
export class SafeHtmlPipe implements PipeTransform  {

  constructor(private sanitized: DomSanitizer) {}

  public transform(value): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
